import type { ComponentType } from 'react';
import type { IconWeight } from '../../../design-system/icons';
import {
  InstagramStoryIcon,
  InstagramReelIcon,
  InstagramPostIcon,
  InstagramCarouselIcon,
  InstagramCollabReelIcon,
  YoutubeShortsIcon,
  YoutubePlayIcon,
} from '../../../components/icons';

// Broader than Phosphor's `Icon` (a ForwardRefExoticComponent) so this slot
// also accepts the hand-authored custom glyphs above (plain function
// components) alongside any Phosphor icon.
export type DeliverableGlyph = ComponentType<{ size?: number; weight?: IconWeight; className?: string }>;

/**
 * Icon + short sublabel per deliverable type — mirrors the content-type
 * cards used on the Create Campaign Deliverables step
 * (apps/brand/src/dashboard/NewCampaign/DeliverablesSection.tsx), reused
 * here so the Approve-creator dialog's deliverable picker matches (Figma
 * nodes 2582:45229 / 2582:45368). Every glyph except YouTube Integrated/
 * Dedicated is a bespoke Figma icon, not a Phosphor lookalike.
 */
export const DELIVERABLE_TYPE_META: Record<string, { Icon: DeliverableGlyph; sub: string; label?: string }> = {
  instagram_stories: { Icon: InstagramStoryIcon, sub: 'Instagram · 24h' },
  instagram_static_post: { Icon: InstagramPostIcon, sub: 'Instagram · Feed' },
  instagram_carousel: { Icon: InstagramCarouselIcon, sub: 'Instagram · Multi' },
  instagram_non_collab_reel: { Icon: InstagramReelIcon, sub: 'Instagram · Video' },
  instagram_collab_reel: { Icon: InstagramCollabReelIcon, sub: 'Instagram · 2 creators' },
  youtube_integrated: { Icon: YoutubePlayIcon, label: 'Integrated', sub: 'YouTube · Sponsors' },
  youtube_dedicated: { Icon: YoutubePlayIcon, label: 'Dedicated', sub: 'YouTube · Long-form' },
  youtube_shorts: { Icon: YoutubeShortsIcon, label: 'Shorts', sub: 'YouTube · Vertical' },
};
